<div class="dialog">

  <img alt="" matPrefix src="assets/images/mail-conf.png">

  <h2 class="first-part">{{ 'globalUi.registration.linkSentTitle' | translate }}</h2>

  <span class="second-part">{{ 'globalUi.emailSent.sentTo' | translate }} <strong>
  </strong> {{ 'globalUi.confirmationPopup.clickLink' | translate }}</span><br />

    <div class="dialog-action">
      <span class="second-part2">{{ 'globalUi.emailSent.notReceived' | translate }}</span>
      <br/>
      <br/>
      <button
        class="btn-resend"
        mat-button
        id="btnCounter"
        (click)="countDown(59); confirmationMail()"
        [disabled]="(this.timer$ | async) == 0 ? !isCount : isCount"
      >
        {{
        (this.timer$ | async) == 0
          ? ('globalUi.confirmationPopup.resend' | translate)
          : "00" + ":" + ((this.timer$ | async)! < 10 ? "0" + (this.timer$ | async) : (this.timer$ | async))
        }}
      </button>
    </div>
</div>
